import React from "react";
const faqData = [
  {
    question: "  What is the GoFlipo TM Panel used for? ",
    answer:
      `The GoFlipo TM Panel allows Telemarketers (TMs) to register and manage their IP addresses,monitor whitelist/ blacklist statuses, view bulk upload reports, and configure SMS routing via "Next Hops" in a compliant and efficient way. `,
  },
  {
    question: "How do I log into the GoFlipo TM Panel? ",
    answer:
      "Visit the GoFlipo Transparency Portal, enter your 19-digit TM ID, and complete the OTP-based multi-factor authentication using your registered email and mobile number. ",
  },
  {
    question: " How can I add a new IP address?",
    answer:
      `Click on ‘Add IP’ from the dashboard, enter the IP and a reference title, then click submit. The IP 
will be auto-enabled and whitelisted immediately upon registration. `
  },
  {
    question: "Can I upload multiple IPs at once? ",
    answer:
      `Yes, use the ‘Bulk Upload’ option. Download the sample template, fill in IPs and titles, save as 
CSV/XLS, upload the file, and click Submit. All IPs will be enabled and whitelisted instantly.`
  },
  {
    question: " What information does the dashboard show? ",
    answer:
      `It summarizes total IPs, enabled/disabled status, and whether IPs are whitelisted or blacklisted. 
It also provides a detailed list of all registered IPs, with enable/disable controls. `
  },
  {
    question: " What happens if one of my IPs gets blacklisted?",
    answer:
      `Blacklisting occurs due to misuse or suspicious activity. You should immediately review the 
issue, take corrective action, and ensure future compliance with TRAI regulations.`
  },
  {
    question: "How can I manage registered IPs after uploading? ",
    answer: `You can enable or disable IPs as needed via the dashboard. This is useful for maintenance or 
route adjustments. Monitor blacklisting risks regularly.`
  }
  ,
  {
    question: " What is the Bulk Report section for?",
    answer: `It lets you track bulk upload history, showing status (success/failure), upload time, and duplicate 
IPs. You can also view specific details of each uploaded batch. `
  }
  ,
  {
    question: `What are "Next Hops" in the TM Panel?`,
    answer: `“Next Hops” are routing configurations that determine how traffic flows to other TMs or 
operators. You can enable, disable, or delete hops and assign TMs/operators to them. `
  }
  ,
  {
    question: " How do I route traffic to other Telemarketers or Operators?",
    answer: `Use the “TMs List” or “Operators List” sections to select a TM/operator and add them to your 
Hops. This helps manage traffic flow efficiently through approved routes.`
  }

];

const FAQItem = ({ que, ans, id }) => {
  return (
    <div className="m-0">
      <div
        className="d-flex align-items-center collapsible py-3 toggle collapsed mb-0"
        data-bs-toggle="collapse"
        data-bs-target={`#kt_job_4_${id}`}
      >
        <div className="btn btn-sm btn-icon mw-20px btn-active-color-primary me-5">
          <span className="svg-icon toggle-on svg-icon-primary svg-icon-1">
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                opacity="0.3"
                x={2}
                y={2}
                width={20}
                height={20}
                rx={5}
                fill="currentColor"
              />
              <rect
                x="6.0104"
                y="10.9247"
                width={12}
                height={2}
                rx={1}
                fill="currentColor"
              />
            </svg>
          </span>
          <span className="svg-icon toggle-off svg-icon-1">
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                opacity="0.3"
                x={2}
                y={2}
                width={20}
                height={20}
                rx={5}
                fill="currentColor"
              />
              <rect
                x="10.8891"
                y="17.8033"
                width={12}
                height={2}
                rx={1}
                transform="rotate(-90 10.8891 17.8033)"
                fill="currentColor"
              />
              <rect
                x="6.01041"
                y="10.9247"
                width={12}
                height={2}
                rx={1}
                fill="currentColor"
              />
            </svg>
          </span>
        </div>
        <h4 className="text-gray-700 fw-bold cursor-pointer mb-0">
          {que}
        </h4>
      </div>
      <div id={`kt_job_4_${id}`} className="collapse fs-6 ms-1">
        <div className="mb-4 text-gray-600 fw-semibold fs-6 ps-10 white-space-pre-line">
          {ans}
        </div>
      </div>
      <div className="separator separator-dashed" />
    </div>
  )
}
const FAQ = () => {
  return (
    <div className="card">
      <div className="card-body p-10 p-lg-15">
        <div className="mb-13">
          <div className="mb-15">
            <h4 className="fs-2x text-gray-800 w-bolder mb-6">
              Frequently Asked Questions
            </h4>
            <p className="fw-semibold fs-4 text-gray-600 mb-2">
              First, a disclaimer – the entire process of writing a blog post often
              takes more than a couple of hours, even if you can type eighty words
              as per minute and your writing skills are sharp.
            </p>
          </div>
          <div className="row mb-12">
            <div className=" pe-md-10 mb-10 mb-md-0">
              {faqData.map((faq, index) => (
                <FAQItem ans={faq.answer} id={index} que={faq.question} key={index} />
              ))}


            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default FAQ